import { useEffect } from "react";

import { css } from "@compiled/react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import {
    ufoEventRedirectToProduct,
    UfoCustomTimingKey,
    UfoCustomTimingWrapper
} from "@/components/signup/utils";

import {
    ProgressCircleContainer,
    ProgressContainerProps
} from "../components/progress-circle/progress-circle-container";
import { useSignupProvisioningContext } from "../signup-provisioning-context";

// eslint-disable-next-line @compiled/no-exported-css
export const FullHeightWrapper = css({
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

export const DefaultCircleLayout = ({
    skipDefaultRedirect,
    ...progressContainerProps
}: {
    skipDefaultRedirect?: boolean;
} & ProgressContainerProps) => {
    const { status, createRedirectUrl } = useSignupProvisioningContext();
    const { createAnalyticsEvent } = useAnalyticsEvents();

    createAnalyticsEvent({
        eventName: "signupProvisioningModuleViewed",
        eventComponent: "confirmationPage",
        event: "viewed",
        eventType: "ui"
    }).fire("signup");

    useEffect(() => {
        if (skipDefaultRedirect) {
            return;
        }

        if (status === "success") {
            const redirectUrl = createRedirectUrl();

            createAnalyticsEvent({
                eventName: "redirectedToProduct",
                eventComponent: "confirmationPage",
                event: "redirected",
                eventType: "ui",
                action: "redirected"
            }).fire();

            // SLO "good event" for redirect into product
            ufoEventRedirectToProduct.success({
                customData: {
                    reactComponent: "DefaultCircleLayout",
                    analyticsEvent: "redirected",
                    redirectFrom: "confirmationPage",
                    provisioningStatus: status
                }
            });

            window.location.assign(redirectUrl);
            return;
        }
    }, [createRedirectUrl, status]);

    return (
        <UfoCustomTimingWrapper
            ufoEvent={ufoEventRedirectToProduct}
            ufoCustomTimingKey={
                UfoCustomTimingKey.CONFLUENCE_DEFAULT_CIRCLE_DWELL_TIME
            }
        >
            <div css={FullHeightWrapper}>
                <ProgressCircleContainer {...progressContainerProps} />
            </div>
        </UfoCustomTimingWrapper>
    );
};
